import { IQuickEditModel, QuickEditModel } from '@/models/quickEdit/QuickEdit';

export interface IDexieQuickEditModel extends IQuickEditModel {
    id?: number;
}

export class DexieQuickEditModel extends QuickEditModel implements IDexieQuickEditModel {
    public id?: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieQuickEditModel);
     // tslint:disable-next-line: unified-signatures
     constructor(obj: IQuickEditModel);
    // tslint:disable-next-line: unified-signatures
    constructor(obj?: any) {
        super(obj && obj as IQuickEditModel);
        if (obj && obj.id) {
            this.id = obj && obj.id;
        }
    }
}
